/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.indexOf("/products/") !== -1) {
    document.addEventListener("variant:changed", function (event) {
      let variant = event.detail.variant; // Gives you access to the whole variant details
      let form = event.target;
      if (!variant.available) {
        const wrapper = form.querySelector(".loader-button__text");
        const originalHTML = wrapper.innerHTML;
        wrapper.innerHTML = `<a class="btn klaviyo-bis-trigger show" href="#" style="text-align: center; margin: 0px; width: 100%;">
                      ${originalHTML}
        </a>`;
      }
    });
  }

  //Hide images that are not relevant to variant
  if (!document.querySelector(".product[data-productbundles]")) {
    if (window.location.pathname.indexOf("/products/") !== -1) {
      const desktopImagesWrapper = document.querySelector(
        ".desktop-images-wrapper",
      );
      const desktopImages = document.querySelectorAll(
        ".desktop-images-wrapper > div",
      );
      const desktopThumbs = document.querySelectorAll(
        ".desktop-media-wrapper .product__thumbnail-list-inner button",
      );
      const mobileImages = document.querySelectorAll(
  ".product__media-image-wrapper > div[data-color]",
);
      const navDots = document.querySelectorAll(
        "product-media .dots-nav button",
      );
      const thumbnails = document.querySelectorAll(
        "product-media .product__thumbnail-list-inner button",
      );
      const previewType = navDots.length == 0 ? thumbnails : navDots;

      for (var i = 0; i < mobileImages.length; i++) {
        const current = mobileImages[i];
        if (current.classList.value.includes("hide-variant-img")) {
          if (previewType[i]) {
            previewType[i].style.display = "none";
          }
        } else {
          if (previewType[i]) {
            previewType[i].style.display = "block";
          }
        }
      }

      //get rid of unused desktop thumbnails
      function syncDesktopThumbs() {
        for (var i = 0; i < desktopThumbs.length; i++) {
          const current = desktopImages[i];
          if (current.classList.value.includes("hide-variant-img")) {
            desktopThumbs[i].style.display = "none";
          } else {
            desktopThumbs[i].style.display = "inline-block";
          }
        }
      }

      for (var i = 0; i < desktopThumbs.length; i++) {
        const current = desktopImages[i];
        desktopThumbs[i].addEventListener("click", function (e) {
          desktopImagesWrapper.scroll({
            top: current.offsetTop,
            left: 0,
            behavior: "smooth",
          });
        });
      }
      syncDesktopThumbs();

 const colorSelector = Array.from(document.querySelectorAll('.product-form__option-selector')).find(function (el) {
  const nameEl = el.querySelector('.product-form__option-name');
  return nameEl && nameEl.textContent.trim().toLowerCase().indexOf('farbe') === 0;
});
const colorValueElement = colorSelector ? colorSelector.querySelector('.product-form__option-value') : null;

function applyColorFilter(selectedColor) {
  document.querySelectorAll('.desktop-images-wrapper > div').forEach(function (current, i) {
    const match = !current.dataset.color || current.dataset.color === selectedColor;
    current.classList.toggle('hide-variant-img', !match);
    current.style.display = match ? '' : 'none';
  });

  document.querySelectorAll('.product__media-image-wrapper > div[data-color]').forEach(function (current) {
    const match = !current.dataset.color || current.dataset.color === selectedColor;
    current.classList.toggle('hide-variant-img', !match);
  });

  syncDesktopThumbs();

  const dripGallery = document.querySelector('drip-gallery');
  if (dripGallery) {
    const hiddenIndexes = [];
    Array.from(dripGallery.querySelectorAll('.TWE-104-content-carousel-slider-item')).forEach(function (item, idx) {
      if (item.dataset.color && item.dataset.color !== selectedColor) {
        hiddenIndexes.push(idx);
      }
    });
    dripGallery.filterByIndex(hiddenIndexes);
  }

  // Kaching koppelt das Spannbettlaken-Upsell nicht an die Produktfarbe.
  // Signal fuer kaching-helper.js, das den Abgleich uebernimmt.
  document.dispatchEvent(
    new CustomEvent("twentythree:color-changed", { detail: { color: selectedColor } })
  );
}

if (colorValueElement) {
  new MutationObserver(function () {
    applyColorFilter(colorValueElement.textContent.trim());
  }).observe(colorValueElement, { childList: true, characterData: true, subtree: true });

  applyColorFilter(colorValueElement.textContent.trim());
}
    }
  }

  document.addEventListener("variant:changed", function (event) {
    const deliveryTexts = document.querySelectorAll(".delivery-text");
    for (var i = 0; i < deliveryTexts.length; i++) {
      const current = deliveryTexts[i];
      if (current.dataset.variant == event.detail.variant.id) {
        current.classList.remove("hidden");
      } else if (!current.classList.contains("hidden")) {
        current.classList.add("hidden");
      }
    }
  });

  if (document.querySelector(".info-icon-wrapper")) {
    var infoIcons = document.querySelectorAll(".info-icon-wrapper");
    infoIcons.forEach((icon) => {
      icon.addEventListener("click", function () {
        icon
          .closest(".text-above-title")
          .querySelector(".product-text")
          .classList.toggle("hidden");
        icon
          .closest(".text-above-title")
          .querySelector(".trees-planted-text")
          .classList.toggle("hidden");
      });
    });
  }

  class StockAlert extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.variants = JSON.parse(this.getAttribute("data-stocks"));

      this.stockdata = JSON.parse(this.getAttribute("data-strings"));
      this.element = this;
      this.getStock(Object.keys(this.variants)[0]);

      document.addEventListener("variant:changed", (event) => {
        if (event.detail.variant.id) {
          this.getStock(event.detail.variant.id);
        }
      });

      let varId = parseInt(this.getAttribute("data-current"));
      this.getStock(varId);
    }

    getStock(id) {
      var currentstock = this.variants[id];
      console.log(currentstock, this.stockdata);

      var keys = Object.keys(this.stockdata).map(function (i) {
        if (i != "max") {
          return parseInt(i);
        } else {
          return "max";
        }
      });
      keys.sort(function (a, b) {
        return a - b;
      });

      //Second last is max value
      var firstStock = parseInt(keys[keys.length - 2]);
      let element = this.element;
      if (currentstock > firstStock) {
        let stockText = this.stockdata["max"];

        console.log("currentstock:", currentstock);

        element.querySelector("div").style.color = "";
        element.style.setProperty("--stock-alert-color", "#288872");
        element.querySelector("div").textContent = stockText;
        return;
      }

      if (currentstock <= 0) {
        element.querySelector("div").style.color = "#288872";
        element.style.setProperty("--stock-alert-color", "#288872");

        let noStockText = this.stockdata["0"];

        if (this.stockdata[`${this.getAttribute("data-current-handle")}-0`]) {
          noStockText =
            this.stockdata[`${this.getAttribute("data-current-handle")}-0`];
        }

        if (this.stockdata[`${id}-0`]) {
          noStockText = this.stockdata[`${id}-0`];
        }

        element.querySelector("div").textContent = noStockText;
        element.querySelector("input").value = noStockText;

        return;
      }

      var itemstock = this.variants[id];

      for (var i = 0; i < keys.length; i++) {
        ////console.log(itemstock, keys[i], keys[i+1]);

        if (itemstock >= keys[i] && itemstock < keys[i + 1]) {
          console.log(this.stockdata[keys[i + 1]]);
          var text = this.stockdata[keys[i + 1]].replace(
            "[amount]",
            currentstock,
          );
          element.querySelector("div").style.color = "";
          element.style.setProperty("--stock-alert-color", "#288872");
          element.querySelector("div").textContent = text;
          element.querySelector("input").value = text;
          break;
        }
      }
    }
  }
  // Define the custom element
  window.customElements.define("stock-alert", StockAlert);

  // Create a class that extends HTMLElement
  class CountDownTimer extends HTMLElement {
    constructor() {
      super();
      this.endTime = new Date(this.getAttribute("data-enddate"));
      this.endTime = new Date(
        this.getAttribute("data-enddate") + "T00:00:00+01:00",
      ); // Winterzeit (MESZ)
      this.initialHtml = this.innerHTML;
    }

    connectedCallback() {
      if (this.endTime != "") {
        this.init();
        this.startCountdown();
      }
    }

    init() {
      const today = new Date();

      let difference = this.endTime - today;
      const millisecondsInADay = 1000 * 60 * 60 * 24;

      const oneDay = 24 * 60 * 60 * 1000;
      this.days = Math.floor(difference / oneDay);
      this.hours = Math.floor((difference % oneDay) / (1000 * 60 * 60));
      this.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((difference % (1000 * 60)) / 1000);

      this.innerHTML = this.getString(this.initialHtml);
      this.setAttribute("inited", true);
    }

    getString(replaceText) {
      const days = this.days;
      const hours = this.hours;
      const minutes = this.minutes;
      const seconds = this.seconds;
      replaceText = replaceText.replace(/\[dd\]/g, days);
      replaceText = replaceText.replace(/\[hh\]/g, hours);
      replaceText = replaceText.replace(/\[mm\]/g, minutes);
      replaceText = replaceText.replace(/\[ss\]/g, seconds);
      return replaceText;
    }

    startCountdown() {
      // Update the countdown every second
      this.countdownInterval = setInterval(() => {
        if (
          this.daysDifference <= 0 &&
          this.hours <= 0 &&
          this.minutes <= 0 &&
          this.seconds <= 0
        ) {
          this.innerHTML = "fertig";
          clearInterval(this.countdownInterval);
        } else {
          this.init();
        }
      }, 1000);
    }

    disconnectedCallback() {
      // Stop the interval when the element is removed
      clearInterval(this.countdownInterval);
    }

    // You can define element functionality
    // E.g., connectedCallback, disconnectedCallback, attributeChangedCallback, etc.
  }

  // Define the custom element
  customElements.define("countdown-timer", CountDownTimer);

  class filterElement extends HTMLElement {
    constructor() {
      super();
      this.target = document.querySelector(this.getAttribute("target"));

      if (this.target) {
        this.init();
      }
    }

    init() {
      this.filtergrid = this.target;
      this.buttons = this.querySelectorAll("[data-filter]");
      this.buttons.forEach((button) => {
        button.addEventListener("click", this.handleClick.bind(this));
      });
    }

    handleClick(event) {
      this.buttons.forEach((button) => {
        button.removeAttribute("selected");
      });
      const clickedElement = event.target.closest("[data-filter]");
      clickedElement.setAttribute("selected", true);
      let prefix = clickedElement.getAttribute("data-filter");
      let value = clickedElement.getAttribute("data-values");
      //console.log(value, prefix);
      this.handleFilter(prefix, value);
    }

    handleFilter(prefix, ParentValue) {
      let parentArray = ParentValue.split(",");
      let filterAttribute = `filter-${prefix.toLowerCase()}`;
      let items = this.filtergrid.querySelectorAll("product-item");
      for (const item of items) {
        if (parentArray.includes(item.getAttribute(filterAttribute))) {
          item.style.display = "flex";
        } else {
          item.style.display = "none";
        }
        if (prefix == "all") {
          item.style.display = "flex";
        }
      }
    }
  }
  customElements.define("filter-element", filterElement);

  function searchWidget() {
    const widgetElement = document.querySelectorAll("etrusted-widget");

    widgetElement.forEach((element) => {
      if (element.closest(".desktop-announcement-bar-text")) {
        element.closest(".desktop-announcement-bar-text").style.padding = 0;
      }

      if (element.closest(".announcement-bar__message")) {
        element.closest(".announcement-bar__message").style.padding = 0;
      }
    });

    if (widgetElement.length > 0) {
      clearInterval(intervalId);
    }

    //console.log(widgetElement.querySelector('etrusted-trusted-stars-service-widget'));
  }

  // Run the search every 4 seconds
  const intervalId = setInterval(searchWidget, 200);

  class discountStock extends HTMLElement {
    constructor() {
      super();
      this.variants = JSON.parse(this.getAttribute("variant-json"));
      console.log(this.variants);
    }
  }
  customElements.define("discount-stock", discountStock);

  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.readmore = this.querySelector(".more-info");
    }

    connectedCallback() {
      if (!JSON.parse(this.getAttribute("inited"))) {
        this.addEventListener("click", this.handleClick.bind(this));
        this.setAttribute("inited", true);
      }
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick.bind(this));
    }

    handleClick(e) {
      console.log(e.target.closest(".rmore-info"));
      if (e.target.closest(".more-info")) {
        this.classList.toggle("expanded");
      }
    }
  }
  customElements.define("image-tooltip", ToolTip);

  var MAX_TRIES = 5;
  var RETRY_DELAY = 400;

  /** Aktuell gewaehlte Farbe – gleiche Quelle wie applyColorFilter(). */
  function readSelectedColor() {
    var selector = Array.from(
      document.querySelectorAll(".product-form__option-selector"),
    ).find(function (el) {
      var name = el.querySelector(".product-form__option-name");
      return name && name.textContent.trim().toLowerCase().indexOf("farbe") === 0;
    });
    var value =
      selector && selector.querySelector(".product-form__option-value");
    return value ? value.textContent.trim() : null;
  }

  class TT0028 extends HTMLElement {
    constructor() {
      super();
      this.state = null;
      this.block = null;
      this._tries = 0;
      this._onSelection = this._onSelection.bind(this);
      this._onColor = this._onColor.bind(this);
      // Legacy: feste Liste pro Einzelfarb-Produkt.
      this.legacy_contents = this._json("data-content-json") || [];
      // Neu: { "Farbname": [{title, images}] } vom kombinierten Produkt.
      this.color_contents = this._json("data-color-content-json") || {};
      this.color = null;
    }

    _json(attr) {
      var raw = this.getAttribute(attr);
      if (!raw) return null;
      try {
        return JSON.parse(raw);
      } catch (e) {
        console.warn("[TT-0028] " + attr + " ist kein gueltiges JSON", e);
        return null;
      }
    }

    /**
     * Bundle-Inhalt fuer die aktive Farbe. Faellt auf die Legacy-Liste zurueck,
     * solange es fuer die Farbe keinen Metaobject-Eintrag gibt – so laufen
     * Einzelfarb-Produkte und das kombinierte Produkt parallel weiter.
     */
    _contents() {
      if (this.color) {
        var wanted = this.color.trim().toLowerCase();
        var keys = Object.keys(this.color_contents);
        for (var i = 0; i < keys.length; i++) {
          if (keys[i].trim().toLowerCase() !== wanted) continue;
          var hit = this.color_contents[keys[i]];
          if (hit && hit.length) return hit;
        }
      }
      return this.legacy_contents;
    }

    connectedCallback() {
      this.color = readSelectedColor();
      document.addEventListener("kaching:selection", this._onSelection);
      document.addEventListener("twentythree:color-changed", this._onColor);
      this._attempt();
    }

    disconnectedCallback() {
      document.removeEventListener("kaching:selection", this._onSelection);
      document.removeEventListener("twentythree:color-changed", this._onColor);
      clearTimeout(this._retryTimer);
    }

    /**
     * Farbwechsel aendert nur, welche Produkte gezeigt werden – die
     * Kaching-Auswahl (Mengen, Upsells) bleibt. Deshalb ohne neuen
     * kachingReadSelection()-Durchlauf direkt neu rendern.
     */
    _onColor(e) {
      var next = e.detail && e.detail.color;
      if (!next || next === this.color) return;
      this.color = next;
      if (this.state) this.parseItems(this.state);
    }

    /* ----------------------------------------------------------- lookup */

    _attempt() {
      this._tries++;

      var block = document.querySelector("kaching-bundles-block");
      var state =
        block && window.kachingReadSelection
          ? window.kachingReadSelection(block)
          : null;

      if (state) {
        this.block = block;
        this.blockId = block.getAttribute("deal-block-id");
        console.log(
          "[TT-0028] Kaching bereit nach " + this._tries + " Versuch(en)",
        );
        this._apply(state, "initial-read");
        return;
      }

      if (this._tries >= MAX_TRIES) {
        console.warn(
          "[TT-0028] Kaching nach " + MAX_TRIES + " Versuchen nicht bereit",
          {
            blockGefunden: !!block,
            helperGeladen: typeof window.kachingReadSelection === "function",
          },
        );
        return;
      }

      console.log(
        "[TT-0028] Versuch " +
          this._tries +
          "/" +
          MAX_TRIES +
          " – noch nicht bereit",
      );
      this._retryTimer = setTimeout(this._attempt.bind(this), RETRY_DELAY);
    }

    /* ----------------------------------------------------------- events */

    _onSelection(e) {
      // Falls das init-Event schneller war als unsere Schleife
      if (!this.block) {
        this.block = document.querySelector("kaching-bundles-block");
        this.blockId = this.block && this.block.getAttribute("deal-block-id");
        clearTimeout(this._retryTimer);
      }
      if (this.blockId && e.detail.blockId !== this.blockId) return;

      this._apply(e.detail.state, e.detail.reason);
    }

    _apply(state, reason) {
      this.state = state;
      //this.log(state, reason);

      this.parseItems(state);
    }

    /** Parse Items */
    parseItems(state) {
      this.bundleDisplay = {};
      this.upsellDisplay = {};

      let contents = this._contents();
      if (!contents || !contents.length) {
        // Keine Daten fuer diese Farbe – lieber nichts zeigen als eine leere Box.
        this.innerHTML = "";
        return;
      }

      let cushion = contents.find((item) => item.title.includes("Kissen"));

      let blanket = contents.find((item) => item.title.includes("Deckenbezug"));

      if (cushion) {
        this.bundleDisplay["cushion"] = {
          title: "Kissenbezug",
          img: cushion.images[0] || null,
          amount: 0,
        };
      }

      if (blanket) {
        this.bundleDisplay["blanket"] = {
          title: "Deckenbezug",
          img: blanket.images[0] || null,
          amount: 0,
        };
      }

      // Auf Kissen/Decke pruefen: pflegt jemand eine Farbe unvollstaendig ein,
      // fehlt der Eintrag – ohne Guard wuerde die ganze Anzeige hart brechen.
      state.items.forEach((motherProduct) => {
        let isDoubleCushioned = motherProduct.variantTitle.includes("(2x)");
        if (this.bundleDisplay["cushion"]) {
          this.bundleDisplay["cushion"].amount += isDoubleCushioned ? 2 : 1;
        }
        if (this.bundleDisplay["blanket"]) {
          this.bundleDisplay["blanket"].amount++;
        }
      });

      if (state.upsells.length) {
        state.upsells
          .filter((upsell) => upsell.selected)
          .forEach((upsell) => {
            let productId = upsell.product.productId;
            let upsellProduct = contents.find((item) =>
              item.title.includes("Spannbettlaken"),
            );

            if (!this.upsellDisplay[productId]) {
              this.upsellDisplay[productId] = {
                title: `Spannbettlaken`,
                img: upsellProduct ? upsellProduct.images[0] || null : null,
                amount: 0,
              };
            }
            this.upsellDisplay[productId].amount++;
          });
      }
      this.renderContent();
    }

    renderContent() {
      function renderBlock(imgSrc, amount) {
        return `
        <div class="tt-0028-includes-block">
          <img src="${imgSrc}">
          ${amount ? "<div class='tt-0028-amount'>" + amount + "</div>" : ""}
        </div>
        `;
      }

      let blocks = [];
      if (this.bundleDisplay["blanket"]) blocks.push(this.bundleDisplay["blanket"]);
      if (this.bundleDisplay["cushion"]) blocks.push(this.bundleDisplay["cushion"]);
      blocks = blocks.concat(Object.values(this.upsellDisplay));

      let contentText = blocks
        .map((block) => `${block.amount}x ${block.title}`)
        .join(" + ");

      let imagesHtml = blocks
        .map((block) => renderBlock(block.img, block.amount))
        .join("");

      this.innerHTML = `
        <div class="tt-0028-container">
          <div class="tt-0028-text">
            <span class="tt-0028-title">Das ist drin:</span>
            <span class="tt-0028-content">${contentText}</span>
          </div>
          <div class="tt-0028-images">
            ${imagesHtml}
          </div>
        </div>
      `;
    }

    /* -------------------------------------------------------------- log */

    log(state, reason) {
      // console.table(
      //   state.items.map(function (i) {
      //     return {
      //       Produkt: i.productTitle,
      //       Variante: i.variantTitle,
      //       VariantId: i.variantId,
      //       Gratis: !!i.isFree,
      //       Preis: i.price,
      //     };
      //   }),
      // );
      // var chosen = state.upsells.filter(function (u) {
      //   return u.selected;
      // });
      // console.log("Upsells gewählt:", chosen.length ? chosen : "keine");
      // console.log("Varianten-IDs für ATC:", state.variantIds);
    }

    /* ----------------------------------------------------- öffentliche API */

    getSelection() {
      return (
        (this.block && window.kachingReadSelection
          ? window.kachingReadSelection(this.block)
          : null) || this.state
      );
    }
  }

  window.customElements.define("tt-0028", TT0028);

  // disabled - TWE-3 implemented in snippets/product-info.liquid
  // (function () {
  //   const globalVariables = { testName: "TWE-3", pageInitials: "TWE-3__pdp-add-content" };
  //   function createLayout() {
  //     waitForElem(".product-meta__taxes-included", () => {
  //       document.querySelector(".product-meta__price-list-container")
  //         .insertAdjacentHTML("afterend", '<p class="TWE-3__new-content text--small">...</p>');
  //     });
  //   }
  //   waitForElem(`body:not(.TWE-3__pdp-add-content)`, () => {
  //     document.body.classList.add("TWE-3__pdp-add-content");
  //     createLayout();
  //   });
  // })();

  // disabled - TWE-13 implemented natively in snippets/product-item.liquid + custom.css (breakpoint 740px)
  // (() => { ... TWE-13 ... })();

  //# sourceURL=ABtest/TWE-13_1.js
});

class Twe37Module extends HTMLElement {
  connectedCallback() {
    const content = this.querySelector(".twe37-content");
    const btn = this.querySelector(".twe37-mehr");
    if (!content || !btn) return;

    btn.addEventListener("click", () => {
      const expanded = content.classList.toggle("twe37-expanded");
      btn.classList.toggle("closed", !expanded);
      btn.querySelector("p").textContent = expanded
        ? "Weniger Infos"
        : "Mehr Infos";
    });
  }
}
customElements.define("twe-37-module", Twe37Module);

document.addEventListener("DOMContentLoaded", () => {
  const infos = document.querySelectorAll(".variant-color-info");

  infos.forEach((info) => {
    const btn = info.querySelector(".info-icon-btn");
    const popup = info.querySelector(".info-popup");

    // Nur auf Touch-Geräten nutzen wir Klick
    if (window.matchMedia("(hover: none)").matches) {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        popup.classList.toggle("visible");
      });
    }
  });

  // Klick irgendwo außerhalb schließt offene Popups
  document.addEventListener("click", () => {
    document.querySelectorAll(".info-popup.visible").forEach((p) => {
      p.classList.remove("visible");
    });
  });
});


// (() => {
//   // utils/common.js
//   function poll(condition, callback, persistent = false, timeout = 1e4, pollInterval = 25) {
//     if (condition()) {
//       callback(condition());
//     } else if (timeout > 0) {
//       setTimeout(() => {
//         poll(condition, callback, persistent, persistent ? timeout : timeout - pollInterval, pollInterval);
//       }, pollInterval);
//     }
//   }
//   function q(s, o) {
//     return o ? s.querySelector(o) : document.querySelector(s);
//   }
//   function qq(s, o) {
//     return o ? [...s.querySelectorAll(o)] : [...document.querySelectorAll(s)];
//   }
//   function insert(target, position, element, exists) {
//     try {
//       if (!exists) {
//         typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
//       }
//     } catch (e) {
//       console.debug(position, " :: ", element);
//     }
//   }

//   // src/Twentythree/TWE-21/V1/info.js
//   var ID = "TWE-21";
//   var VAR = "V1";
//   function expLog() {
//     window.runningExperiments[ID].logs.push([...arguments]);
//   }

//   // src/Twentythree/TWE-21/V1/index.js
//   function testInfo(testName) {
//     window.runningExperiments = window.runningExperiments || {};
//     window.runningExperiments[ID] = {
//       name: testName || "",
//       variation: `${VAR}`,
//       logs: []
//     };
//     poll(
//       () => q("body"),
//       () => {
//         q("body").classList.add(`${ID}`, `${ID}_${VAR}`);
//       }
//     );
//   }
//   function addBadge() {
//     poll(
//       () => q(".product__info .color-swatch label") && q(".product-meta__price-list-container .label"),
//       () => {
//         const markup = `<span class = "${ID}__badge"></span>`;
//         qq(".product__info .color-swatch label").forEach((el) => {
//           insert(el, "beforeend", markup, q(el, `.${ID}__badge`));
//         });
//       }
//     );
//   }
//   async function getDiscountsForSelectedVariant() {
//     const pathname = location.pathname;
//     const response = await fetch(`${location.origin}${pathname}.json`);
//     const data = await response.json();
//     const variants = data.product.variants;
//     const formattedVariants = variants.map((variant) => {
//       const price = parseFloat(variant.price);
//       const compareAtPrice = parseFloat(variant.compare_at_price);
//       const fractionDiscount = compareAtPrice && price ? (price - compareAtPrice) / compareAtPrice * 100 : 0;
//       const discount = Math.round(fractionDiscount);
//       return {
//         option1: variant.option1,
//         option2: variant.option2,
//         option3: variant.option3,
//         discount
//       };
//     });
//     return formattedVariants;
//   }
//   async function getDiscountForSelectedSize() {
//     const discounts = await getDiscountsForSelectedVariant();
//     let discount = null;
//     expLog("discounts", discounts);
//     if (discounts.length === 1) {
//       discount = discounts[0].discount;
//       expLog("discount", discount);
//       return discount;
//     } else if (discounts.length > 1) {
//       poll(
//         () => q(".product__info .block-swatch input:checked"),
//         () => {
//           if (qq(".block-swatch input:checked").length > 1) {
//             discount = discounts.find((discount2) => discount2.option2 === qq(".block-swatch input:checked")[0].value && discount2.option3 === qq(".block-swatch input:checked")[1].value).discount;
//             expLog("discount", discount);
//           } else {
//             discount = discounts.find((discount2) => discount2.option2 === q(".block-swatch input:checked").value).discount;
//             expLog("discount", discount);
//           }
//         }
//       );
//       if (discount) {
//         return discount;
//       }
//     }
//   }
//   async function getDOM(url, selector) {
//     const response = await fetch(url);
//     const html = await response.text();
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(html, "text/html");
//     return selector ? doc.querySelector(selector) : doc;
//   }
//   async function getDefaultDiscount(url = `${location.origin}${location.pathname}`) {
//     const defaultDiscountEl = await getDOM(url, ".product-meta__price-list-container .label--highlight");
//     const variant = url.split("/").pop();
//     if (defaultDiscountEl) {
//       const defaultDiscount = defaultDiscountEl.textContent;
//       expLog("defaultDiscount", url, defaultDiscount);
//       return { defaultDiscount, variant };
//     } else {
//       const defaultDiscount = 0;
//       return { defaultDiscount, variant };
//     }
//   }
//   async function getDefaultDiscountForAllVariants() {
//     const promiseList = [];
//     qq("a.color-swatch").forEach((el) => {
//       const url = el.href;
//       promiseList.push(getDefaultDiscount(url));
//     });
//     const defaultDiscounts = await Promise.all(promiseList);
//     if (defaultDiscounts) {
//       expLog("defaultDiscounts", defaultDiscounts);
//       return defaultDiscounts;
//     }
//   }
//   async function addDiscountValueForSelectedVariant() {
//     const defaultData = await getDefaultDiscount();
//     const { defaultDiscount, variant } = defaultData;
//     expLog("defaultDiscount for selected variant", defaultDiscount, variant);
//     const discount = await getDiscountForSelectedSize();
//     expLog("discount for selected size", discount);
//     poll(
//       () => q(`.product__info div.color-swatch label .${ID}__badge`) && q(".product-meta__price-list-container .label"),
//       () => {
//         if (q(".product-meta__price-list-container .label.label--highlight") && discount) {
//           q(`.product__info div.color-swatch label .${ID}__badge`).textContent = `${discount}%`;
//         } else if (defaultDiscount === 0) {
//           q(`.product__info div.color-swatch label .${ID}__badge`).classList.add("sold");
//           q(`.product__info div.color-swatch label .${ID}__badge`).textContent = "SOLD";
//         } else {
//           q(`.product__info div.color-swatch label .${ID}__badge`).textContent = `${defaultDiscount}`;
//         }
//       }
//     );
//   }
//   function addDiscountValueForAllVariants() {
//     poll(
//       () => q(`a.color-swatch .${ID}__badge`),
//       async () => {
//         const defaultDiscounts = await getDefaultDiscountForAllVariants();
//         qq(`a.color-swatch`).forEach((el) => {
//           const variant = el.href.split("/").pop();
//           const defaultDiscount = defaultDiscounts.find((discount) => discount.variant === variant).defaultDiscount;
//           const badge = q(el, `.${ID}__badge`);
//           if (defaultDiscount === 0) {
//             badge.classList.add("sold");
//             badge.textContent = "SOLD";
//           } else {
//             badge.textContent = `${defaultDiscount}`;
//           }
//         });
//       }
//     );
//   }
//   function handleMutation() {
//     poll(
//       () => q("product-variants"),
//       () => {
//         const targetNode = q("product-variants");
//         const config = { attributes: true, childList: true, subtree: true };
//         const callback = (mutationsList, obs) => {
//           expLog("mutation", mutationsList);
//           !window.TWE_21 && addDiscountValueForSelectedVariant();
//           window.TWE_21 = true;
//           setTimeout(() => {
//             window.TWE_21 = false;
//           }, 1e3);
//         };
//         const observer = new MutationObserver(callback);
//         observer.observe(targetNode, config);
//       }
//     );
//   }
//   function mainJS() {
//     testInfo("Show Discount Badge Near Color Swatches on PDP");
//     addBadge();
//     addDiscountValueForSelectedVariant();
//     addDiscountValueForAllVariants();
//     handleMutation();
//   }
//   mainJS();
// })();

//# sourceURL=ABtest/TWE-21_V1.js

// disabled - TWE-38 implemented natively in sections/mini-cart.liquid (tag: sleeprelated)
/* (() => {
  var ID = "TWE-38";
  var VAR = "1";
  function expLog() {
    window.runningExperiments[ID].logs.push([...arguments]);
  }

  // src/Twentythree/TWE-38/1/index.js
  function testInfo(testName) {
    window.runningExperiments = window.runningExperiments || {};
    window.runningExperiments[ID] = {
      name: testName || "",
      variation: `${VAR}`,
      logs: []
    };
    poll(
      () => q("body"),
      () => {
        q("body").classList.add(`${ID}`, `${ID}_${VAR}`);
      }
    );
  }
  var EXCLUDED_PRODUCTS = [
    "/products/eukalyptus-scrunchies-shine-mustard",
    "/products/eukalyptus-scrunchies-glassy-white",
    "/products/breeze-raumspray"
  ];
  var OTHER_PRODUCTS = [
    "/products/the-everyday-set-storm-gray",
    "/products/the-everyday-set-ocean-blue",
    "/products/the-family-set-ocean-blue",
    "/products/the-family-set",
    "/products/the-standard-set-ocean-blue",
    "/products/the-standard-set-storm-gray",
    "/products/lyocell-handtuch",
    "/products/lyocell-handtuch-ocean-blue"
  ];
  function getProductTypesInCart() {
    const links = Array.from(document.querySelectorAll('#mini-cart .line-item__content-wrapper a[href*="/products/"]'));
    const productUrls = links.map((link) => new URL(link.href).pathname);
    const hasSleepRelated = productUrls.some(
      (url) => !EXCLUDED_PRODUCTS.includes(url) && !OTHER_PRODUCTS.includes(url)
    );
    const hasOther = productUrls.some((url) => OTHER_PRODUCTS.includes(url));
    const onlyExcluded = productUrls.some((url) => EXCLUDED_PRODUCTS.includes(url));
    console.log("Product URLs in cart:", onlyExcluded);
    return { hasSleepRelated, hasOther, onlyExcluded };
  }
  function findWieLangeTestenElement() {
    const elements = Array.from(document.querySelectorAll(".mini-cart-text-field"));
    return elements.find((el) => {
      const divs = el.querySelectorAll("div");
      return Array.from(divs).some((div) => div.textContent.includes("Wie lange testen?"));
    });
  }
  function insertBadge() {
    const form = q("#mini-cart-form");
    if (!form)
      return;
    const existingBadge = q(".hundred-night-badge");
    if (existingBadge)
      existingBadge.remove();
    const { hasSleepRelated, hasOther, onlyExcluded } = getProductTypesInCart();
    const wieLangeElement = findWieLangeTestenElement();
    const shouldShowBadge = !(hasSleepRelated && hasOther || onlyExcluded) && (hasSleepRelated || hasOther);
    if (shouldShowBadge) {
      if (wieLangeElement) {
        wieLangeElement.style.display = "none";
      }
      const badgeType = hasSleepRelated ? "sleep" : "other";
      const badge = document.createElement("div");
      badge.className = "hundred-night-badge";
      const iconURL = badgeType === "sleep" ? "https://assets.ablyft.com/96620302/dNXewxfEiPEMUPZ9GYhy56fVN0yUZm6bOaIc6Kgn.svg" : "https://assets.ablyft.com/96620302/mSHOfo3jyjFSwHvbABe20AqA2Fwhnar5ieJBsI3t.svg";
      const checkIcon = "https://assets.ablyft.com/96620302/ljjcq0qqVFstvHduHNwimwJPPCV9N59l8A3LlrZn.svg";
      const bgColor = badgeType === "sleep" ? "#E9EFED" : "#F9F4ED";
      const title = badgeType === "sleep" ? "100 Nächte Probeschlafen & Garantie" : "100 Tage zu Hause testen & Garantie";
      badge.innerHTML = `
      <div class="badge-inner">
        <div class="badge-icon">
          <img src="${iconURL}" alt="pillow icon" width="45" height="45" />
        </div>
        <div class="badge-text">
          <div class="badge-title">${title}</div>
          <div class="badge-sub">
            <span><img class="check-icon" src="${checkIcon}" alt="check" width="10" height="7.5" /> Waschen erlaubt</span>
            <span><img class="check-icon" src="${checkIcon}" alt="check" width="10" height="7.5" /> Einfache Retoure</span>
          </div>
        </div>
      </div>
    `;
      badge.style.backgroundColor = bgColor;
      form.insertAdjacentElement("afterend", badge);
    } else {
      if (wieLangeElement) {
        wieLangeElement.style.display = "";
      }
    }
  }
  function mainJS() {
    testInfo("Highlight 100 Day Testing in Cart");
    poll(() => q("#mini-cart"), () => {
      insertBadge();
      const cartDrawer = q("#mini-cart");
      const observerConfig = {
        childList: true,
        subtree: true
      };
      const observer = new MutationObserver((mutations) => {
        const relevant = mutations.some((mutation) => {
          return !mutation.target.closest(".TWE-59_reservation-timer-bar");
        });
        if (!relevant)
          return;
        observer.disconnect();
        console.log("MutationObserver detected relevant changes in #mini-cart");
        insertBadge();
        observer.observe(cartDrawer, observerConfig);
      });
      observer.observe(cartDrawer, observerConfig);
      expLog("MutationObserver attached to #mini-cart");
    });
  }
  mainJS();
})(); */

//# sourceURL=ABtest/TWE-38_1.js

/* disabled
if (window.innerWidth < 999)
  (() => {
    // utils/alpha/pollFor.js
    function waitFor(condition, callback, endTime = 1e4, pollInterval = 25) {
      if (condition()) {
        callback(condition());
      } else if (endTime > 0) {
        setTimeout(() => {
          waitFor(condition, callback, endTime - pollInterval, pollInterval);
        }, pollInterval);
      }
    }

    // utils/alpha/updateEle.js
    var q = (a, b) => b ? a.querySelector(b) : document.querySelector(a);
    var qa = (a, b) => b ? a.querySelectorAll(b) : document.querySelectorAll(a);
    function insertEle(target, position, element, checkEle) {
      if (!checkEle) {
        typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
      }
    }

    // src/Twentythree/TWE-104/1/info.js
    var ID = "TWE-104";
    var VAR = "1";
    function expLog() {
      window.runningExperiments[ID].logs.push([...arguments]);
    }

    // src/Twentythree/TWE-104/1/func/addBehavior.js
    var setTooltipWidth = () => {
      let smallestItemWidth = Infinity;
      qa(`.${ID}-content-gallery-item`).forEach((item) => {
        const currentWidth = item.getBoundingClientRect().width;
        if (currentWidth < smallestItemWidth)
          smallestItemWidth = currentWidth;
      });
      q(":root").style.setProperty("--tooltip-width", window.innerWidth > 1199 ? `${smallestItemWidth + 12 + 24}px` : `${smallestItemWidth * 2}px`);
    };
    var clickEvent = () => {
      q("body").addEventListener("click", (e) => {
        const targetTooltipButton = e.target.closest(`.${ID}-content-gallery-item-tooltip-header-button, .${ID}-content-carousel-slider-item-tooltip-header-button`);
        const targetGalleryItem = e.target.closest(`.${ID}-content-gallery-item>img:not([alt="overlay"])`);
        const targetZoomControlClose = e.target.closest(`.${ID}-content-zoom-control-close`);
        const targetZoomControlZoom = e.target.closest(`.${ID}-content-zoom-control-zoom>span, .${ID}-content-zoom-control-zoom>svg`);
        const targetMobileZoomButton = e.target.closest(`.${ID}-content-carousel-slider-zoom`);
        if (targetTooltipButton) {
          const base = targetTooltipButton.closest(`.${ID}-content-gallery-item-tooltip, .${ID}-content-carousel-slider-item-tooltip`);
          setTooltipWidth();
          base.classList.toggle("active");
          expLog("tooltip-toggled");
        } else if (targetGalleryItem) {
          const index = parseInt(targetGalleryItem.dataset.index);
          q(`.${ID}-content-zoom`).classList.add("active");
          window.pdpZoomSlider.slideTo(index, 0);
          expLog("zoom-opened", index);
        } else if (targetZoomControlClose) {
          q(`.${ID}-content-zoom`).classList.remove("active");
          if (window.pdpZoomPhotoSwipeLightbox.pswp)
            window.pdpZoomPhotoSwipeLightbox.pswp.close();
          expLog("zoom-closed");
        } else if (targetZoomControlZoom) {
          if (window.pdpZoomPhotoSwipeLightbox.pswp)
            window.pdpZoomPhotoSwipeLightbox.pswp.close();
          else
            q(`.${ID}-content-zoom-slider-item.swiper-slide-active a`).click();
          expLog("zoom-toggled");
        } else if (targetMobileZoomButton) {
          q(`.${ID}-content-gallery-item>[data-index="${q(`.${ID}-content-carousel-slider-item.swiper-slide-active`).dataset.index}"]`).click();
        }
      });
    };
    function addBehavior() {
      setTooltipWidth();
      clickEvent();
      window.pdpZoomSliderThumb = new Swiper(`.${ID}-content-zoom-thumbnail`, {
        slidesPerView: "auto",
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true
      });
      window.pdpZoomSlider = new Swiper(`.${ID}-content-zoom-slider`, {
        spaceBetween: 10,
        navigation: {
          nextEl: `.${ID}-content-zoom-control-navigation>.swiper-button-next`,
          prevEl: `.${ID}-content-zoom-control-navigation>.swiper-button-prev`
        },
        thumbs: {
          swiper: window.pdpZoomSliderThumb
        },
        on: {
          activeIndexChange: (e) => {
            q(`.${ID}-content-zoom-control-number>.current`).innerHTML = e.activeIndex + 1;
            window.pdpSlider.slideTo(e.activeIndex);
            window.pdpZoomSliderThumb.slideTo(e.activeIndex);
            if (window.pdpZoomPhotoSwipeLightbox.pswp)
              window.pdpZoomPhotoSwipeLightbox.pswp.close();
            expLog("active-ndex-change", e.activeIndex);
          }
        }
      });
      window.pdpSliderThumb = new Swiper(`.${ID}-content-carousel-thumbnail`, {
        slidesPerView: "auto",
        spaceBetween: 8,
        freeMode: true,
        watchSlidesProgress: true
      });
      window.pdpSlider = new Swiper(`.${ID}-content-carousel-slider`, {
        slidesPerView: 1.055,
        spaceBetween: 8,
        thumbs: {
          swiper: window.pdpSliderThumb
        },
        on: {
          activeIndexChange: (e) => {
            window.pdpSliderThumb.slideTo(e.activeIndex);
            expLog("active-ndex-change", e.activeIndex);
          }
        }
      });
      window.pdpZoomPhotoSwipeLightbox = new PhotoSwipeLightbox({
        bgOpacity: 1,
        maxSpreadZoom: 1,
        initialZoomLevel: "fill",
        tapAction: "close",
        doubleTapAction: "close",
        imageClickAction: "close",
        showAnimationDuration: 250,
        hideAnimationDuration: 100,
        zoom: false,
        close: false,
        counter: false,
        arrowPrev: false,
        arrowNext: false,
        wheelToZoom: false,
        pinchToClose: false,
        closeOnVerticalDrag: false,
        pswpModule: window.PhotoSwipe,
        showHideAnimationType: "zoom",
        gallery: `.${ID}-content-zoom-slider`,
        children: `.${ID}-content-zoom-slider-item-wrapper`
      });
      window.pdpZoomPhotoSwipeLightbox.init();
      window.pdpZoomPhotoSwipeLightbox.on("change", () => {
        const { pswp } = window.pdpZoomPhotoSwipeLightbox;
        window.pdpZoomSlider.slideTo(pswp.currIndex, 0, false);
        expLog("zoom-slider-changed", pswp.currIndex);
      });
    }

    // src/Twentythree/TWE-104/1/func/addContent.js
    function addContent(base) {
      const swiperScript = document.createElement("script");
      const photoswipeScript = document.createElement("script");
      const photoswipeLightboxScript = document.createElement("script");
      const imageData = [], imageGroup = [];
      let sliderIndex = -1;
      qa(".product__media-image-wrapper>[data-color]").forEach((sliderItem) => {
        const data = {
          img: q(sliderItem, "img:not(.overlay-image)").src.replace("_1800x", "_1024x").replace("_1534x", "_1024x"),
          text: q(sliderItem, "img:not(.overlay-image)").alt,
          overlay: q(sliderItem, "img.overlay-image")?.src,
          tooltipTitle: q(sliderItem, ".tooltip-title")?.textContent.trim(),
          tooltipDescription: q(sliderItem, ".image-tooltip-content p")?.textContent.trim()
        };
        imageData.push(data);
        expLog("slider-item", data);
      });
      const tempData = [...imageData];
      let groupCount = Math.ceil(imageData.length / 4);
      while (groupCount > 0) {
        const tempGroup = [];
        let itemCount = 4;
        if (tempData.length < 4)
          itemCount = tempData.length;
        else if (imageData.length === 4) {
          itemCount = 3;
          groupCount++;
        }
        while (itemCount > 0) {
          tempGroup.push(tempData.shift());
          itemCount--;
        }
        imageGroup.push(tempGroup);
        groupCount--;
      }
      swiperScript.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
      photoswipeScript.src = "https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/umd/photoswipe.umd.min.js";
      photoswipeLightboxScript.src = "https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/umd/photoswipe-lightbox.umd.min.js";
      insertEle(
        base,
        "beforebegin",
        swiperScript,
        q(`[src*="swiper-bundle.min.js"]`)
      );
      insertEle(
        base,
        "beforebegin",
        photoswipeScript,
        q(`[src*="photoswipe.umd.min.js"]`)
      );
      insertEle(
        base,
        "beforebegin",
        photoswipeLightboxScript,
        q(`[src*="photoswipe-lightbox.umd.min.js"]`)
      );
      insertEle(
        base,
        "beforebegin",
        `<div class="${ID}-content">
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"/>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.min.css"/>

      <div class="${ID}-content-gallery">
        ${imageGroup.map((group, groupIndex) => `
          <ul class="${ID}-content-gallery-group" data-position="${(groupIndex + 1) % 2 === 0 ? "left" : "right"}" data-count="${group.length}">
            ${group.map((item, itemIndex) => {
          sliderIndex++;
          return `<li class="${ID}-content-gallery-item ${group.length > 2 && itemIndex > 0 ? "small-item" : ""}">
                <img src="${item.img}" data-index="${sliderIndex}" alt="${item.text}">
                ${item.overlay ? `<img src="${item.overlay}" alt="overlay" />` : ""}
                ${item.tooltipTitle ? `
                <div class="${ID}-content-gallery-item-tooltip">
                  <div class="${ID}-content-gallery-item-tooltip-header">
                    <div class="${ID}-content-gallery-item-tooltip-header-title">${item.tooltipTitle}</div>
                    <div class="${ID}-content-gallery-item-tooltip-header-button">
                      <span>mehr infos</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <path d="M5 0.751262C4.84945 0.751262 4.70378 0.757773 4.56462 0.77161C4.42546 0.785447 4.28467 0.805795 4.14388 0.834283C4.00391 0.861957 3.868 0.896956 3.73698 0.936839C3.60758 0.976722 3.47982 1.02393 3.35449 1.07684L3.34635 1.08091C3.2137 1.13788 3.08757 1.19893 2.96631 1.26404C2.84424 1.32997 2.72705 1.40078 2.61556 1.47566C2.50326 1.55136 2.39421 1.63194 2.29085 1.7174C2.1875 1.80287 2.0874 1.89321 1.99137 1.99007L1.98812 1.99333C1.89209 2.08937 1.80176 2.18867 1.71712 2.29123C1.63167 2.39541 1.55111 2.50366 1.47542 2.61599C1.40055 2.72668 1.33057 2.84389 1.26465 2.96598C1.19954 3.08725 1.1377 3.21423 1.08073 3.34609L1.07666 3.35504L1.07096 3.36643C1.01969 3.48852 0.974121 3.61387 0.935059 3.74166C0.895182 3.87107 0.861816 4.00456 0.834147 4.14293C0.805664 4.28374 0.785319 4.42373 0.771484 4.56373C0.75765 4.70373 0.751139 4.84861 0.751139 4.99919C0.751139 5.14976 0.75765 5.29546 0.771484 5.43464C0.785319 5.57382 0.805664 5.71463 0.834147 5.85545C0.86263 5.99544 0.89681 6.13137 0.9375 6.26241C0.977376 6.3902 1.02295 6.51717 1.07585 6.64171C1.0791 6.6474 1.08154 6.6531 1.08398 6.6588C1.14014 6.78903 1.20036 6.91356 1.26546 7.03321C1.33138 7.1553 1.40218 7.27251 1.47624 7.3832C1.55192 7.49634 1.63249 7.60459 1.71875 7.70877C1.80176 7.8097 1.89046 7.90737 1.98405 8.00098C1.98975 8.00586 1.99463 8.01074 1.99951 8.01644C2.09391 8.11086 2.19157 8.19876 2.29167 8.28178C2.39583 8.36725 2.50407 8.44783 2.61637 8.52352C2.72705 8.5984 2.84424 8.6684 2.96631 8.73433C3.08757 8.79945 3.21452 8.86131 3.34635 8.91828L3.36344 8.92642C3.48714 8.97851 3.61328 9.02409 3.74349 9.06398C3.87207 9.10386 4.00635 9.13723 4.14388 9.1649C4.28467 9.19339 4.42464 9.21374 4.56462 9.22758C4.70459 9.24141 4.84945 9.24792 5 9.24792C5.15055 9.24792 5.29622 9.24141 5.43538 9.22758C5.57454 9.21374 5.71533 9.19339 5.85612 9.1649C5.99609 9.13642 6.132 9.10223 6.26302 9.06153C6.39242 9.02165 6.52018 8.97444 6.64632 8.92072L6.65365 8.91747V8.91665C6.7863 8.85968 6.91244 8.79863 7.03369 8.73352C7.15576 8.66759 7.27295 8.59678 7.38444 8.52189C7.49674 8.4462 7.60579 8.36562 7.70915 8.28016C7.81087 8.19632 7.90853 8.1076 8.00374 8.01237C8.00863 8.00749 8.0127 8.0026 8.01839 7.99772C8.11198 7.90412 8.19987 7.80645 8.28288 7.70633C8.36833 7.60215 8.44971 7.4939 8.52539 7.38076C8.60026 7.27006 8.67025 7.15286 8.73617 7.03077C8.80127 6.90949 8.86312 6.78333 8.92008 6.65066L8.92822 6.63275C8.98031 6.50985 9.02588 6.38369 9.06576 6.25427C9.10563 6.12486 9.139 5.99137 9.16667 5.853C9.19515 5.71219 9.2155 5.5722 9.22933 5.4322C9.24317 5.2922 9.24967 5.14732 9.24967 4.99674C9.24967 4.84617 9.24317 4.70047 9.22933 4.56129C9.2155 4.42211 9.19515 4.2813 9.16667 4.14049C9.13818 4.00049 9.104 3.86456 9.06331 3.73352C9.02344 3.6041 8.97624 3.47631 8.92253 3.35015L8.91927 3.34283C8.8623 3.21016 8.80127 3.084 8.73617 2.96272C8.67025 2.84063 8.59945 2.72342 8.52539 2.61273C8.44971 2.50041 8.36914 2.39134 8.28369 2.28797C8.20068 2.18704 8.11117 2.08856 8.01676 1.99414C8.01107 1.98926 8.00619 1.98437 8.00212 1.97949C7.90772 1.88507 7.81087 1.79717 7.70996 1.71415C7.60579 1.62868 7.49756 1.5481 7.38525 1.47241C7.27376 1.39753 7.15739 1.32753 7.03532 1.2616C6.91406 1.19648 6.78792 1.13462 6.65527 1.07846L6.63981 1.07114C6.51611 1.01905 6.38916 0.972652 6.25895 0.932769C6.13037 0.892886 5.99609 0.859515 5.85775 0.831841C5.71696 0.803353 5.57699 0.783005 5.43701 0.769168C5.29622 0.757773 5.15055 0.751262 5 0.751262ZM5.15462 2.53703C5.33285 2.53703 5.47282 2.58831 5.57454 2.69005C5.67546 2.7918 5.72673 2.93098 5.72673 3.11086C5.72673 3.29318 5.63965 3.45434 5.4655 3.59678C5.28971 3.7384 5.08626 3.81003 4.85352 3.81003C4.67936 3.81003 4.5402 3.76119 4.43359 3.66352C4.32699 3.56422 4.27409 3.43643 4.27409 3.2769C4.27409 3.07586 4.36117 2.9033 4.53369 2.75598C4.7054 2.60947 4.91292 2.53703 5.15462 2.53703ZM6.14828 7.46459H3.85173V7.07797H4.28304V4.71675H3.85173V4.40908H4.92513C5.19613 4.40908 5.46305 4.37653 5.72673 4.30978V7.07797H6.14828V7.46459ZM3.9974 0.0976722C4.1569 0.0659287 4.3221 0.0415107 4.49219 0.025232C4.66227 0.00813935 4.83154 0 5 0C5.16846 0 5.33773 0.00813935 5.50781 0.025232C5.6779 0.0415107 5.8431 0.0659287 6.0026 0.0976722C6.16048 0.129416 6.31836 0.169298 6.47624 0.218134C6.62923 0.265343 6.7806 0.32069 6.93034 0.384177L6.9458 0.389875L6.95068 0.391503C7.10124 0.456617 7.24772 0.52743 7.38851 0.603939C7.52767 0.679635 7.6652 0.762657 7.80111 0.853817C7.93376 0.94335 8.06234 1.03858 8.18604 1.14032C8.30973 1.24206 8.42773 1.34869 8.53923 1.46183C8.65153 1.57415 8.75895 1.69217 8.86068 1.81507C8.9624 1.93879 9.05762 2.06658 9.14714 2.20007C9.23584 2.33274 9.31885 2.47029 9.39616 2.61192H9.39697C9.47347 2.75354 9.54508 2.90005 9.60938 3.05063C9.611 3.0547 9.61263 3.05877 9.61426 3.06284C9.67773 3.21179 9.73307 3.36399 9.78109 3.51864C9.83073 3.67817 9.87142 3.8377 9.90316 3.99805C9.9349 4.15758 9.95931 4.32281 9.97559 4.49292C9.99186 4.66303 10 4.83233 10 5.00081C10 5.1693 9.99186 5.3386 9.97477 5.50871C9.9585 5.67882 9.93408 5.84405 9.90234 6.00358C9.87061 6.16148 9.83073 6.31939 9.7819 6.47729C9.7347 6.63112 9.67855 6.78333 9.61507 6.93472L9.61182 6.94205L9.60775 6.951C9.54264 7.10158 9.47184 7.24809 9.39534 7.3889C9.31966 7.52808 9.23665 7.66564 9.14551 7.80156C9.05599 7.93423 8.96078 8.06284 8.85905 8.18655C8.75732 8.31027 8.65072 8.42748 8.5376 8.5398C8.42529 8.65212 8.30729 8.75956 8.18359 8.86131C8.0599 8.96305 7.93213 9.05828 7.79948 9.147C7.66683 9.23572 7.5293 9.31874 7.3877 9.39606C7.24284 9.4742 7.09717 9.54583 6.94906 9.60931C6.94499 9.61094 6.94092 9.61257 6.93604 9.6142C6.78711 9.67768 6.63493 9.73303 6.48031 9.78105C6.3208 9.8307 6.1613 9.8714 6.00179 9.90314C5.84229 9.93489 5.67708 9.9593 5.507 9.97558C5.33691 9.99186 5.16764 10 4.99919 10C4.83073 10 4.66146 9.99186 4.49137 9.97558C4.32129 9.9593 4.15609 9.93489 3.99658 9.90314C3.8387 9.8714 3.68083 9.83152 3.52295 9.78268C3.36914 9.73547 3.21696 9.67931 3.06641 9.61582L3.05013 9.60931C2.89958 9.5442 2.75309 9.47338 2.6123 9.39687C2.47314 9.32118 2.33561 9.23816 2.19971 9.147C2.06706 9.05828 1.93848 8.96223 1.81559 8.86131C1.69189 8.75956 1.57389 8.65212 1.46159 8.5398C1.34928 8.42748 1.24186 8.30946 1.14014 8.18655C1.03841 8.06284 0.943197 7.93423 0.853678 7.80156C0.764974 7.66889 0.681966 7.53134 0.604655 7.38971C0.525716 7.24483 0.454915 7.09832 0.391439 6.95019C0.389811 6.94612 0.388184 6.94205 0.386556 6.93798C0.323079 6.78903 0.267741 6.63682 0.219727 6.48217C0.170085 6.32264 0.129395 6.1623 0.0976563 6.00277C0.065918 5.84324 0.0415039 5.67801 0.0252279 5.50789C0.00813802 5.3386 0 5.1693 0 5.00081C0 4.83233 0.00813802 4.66303 0.0252279 4.49292C0.0415039 4.32281 0.065918 4.15758 0.0976563 3.99805C0.129395 3.84014 0.169271 3.68224 0.218099 3.52434C0.265299 3.37132 0.320638 3.21993 0.384115 3.06935L0.391439 3.05063C0.456543 2.90005 0.527344 2.75354 0.603841 2.61273C0.679525 2.47355 0.762533 2.33599 0.853678 2.20007C0.943197 2.06739 1.03841 1.93879 1.14014 1.81507C1.24186 1.69136 1.34847 1.57415 1.46159 1.46183C1.57389 1.3495 1.69189 1.24206 1.81478 1.14032C1.93848 1.03858 2.06624 0.94335 2.19971 0.853817C2.33561 0.762657 2.47314 0.679635 2.6123 0.603939L2.62288 0.599056C2.76367 0.522546 2.90609 0.454176 3.05094 0.391503C3.05501 0.389875 3.05908 0.388247 3.06315 0.386619C3.21208 0.323132 3.36426 0.267784 3.51888 0.219762C3.67757 0.170112 3.83708 0.129416 3.9974 0.0976722Z" fill="#212C2F"/>
                      </svg>
                    </div>
                  </div>
                  <div class="${ID}-content-gallery-item-tooltip-description">${item.tooltipDescription}</div>
                </div>` : ""}
              </li>`;
        }).join("")}
          </ul>
        `).join("")}
      </div>

      <div class="${ID}-content-carousel">

        <div class="${ID}-content-carousel-slider swiper">
          <ul class="${ID}-content-carousel-slider-wrapper swiper-wrapper">
            ${imageData.map((item, itemIndex) => `<li class="${ID}-content-carousel-slider-item swiper-slide" data-index="${itemIndex}">
              <img src="${item.img}" alt="${item.text}" />
              ${item.overlay ? `<img src="${item.overlay}" alt="overlay" />` : ""}
              ${item.tooltipTitle ? `
              <div class="${ID}-content-carousel-slider-item-tooltip">
                <div class="${ID}-content-carousel-slider-item-tooltip-header">
                  <div class="${ID}-content-carousel-slider-item-tooltip-header-title">${item.tooltipTitle}</div>
                  <div class="${ID}-content-carousel-slider-item-tooltip-header-button">
                    <span>mehr infos</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <path d="M5 0.751262C4.84945 0.751262 4.70378 0.757773 4.56462 0.77161C4.42546 0.785447 4.28467 0.805795 4.14388 0.834283C4.00391 0.861957 3.868 0.896956 3.73698 0.936839C3.60758 0.976722 3.47982 1.02393 3.35449 1.07684L3.34635 1.08091C3.2137 1.13788 3.08757 1.19893 2.96631 1.26404C2.84424 1.32997 2.72705 1.40078 2.61556 1.47566C2.50326 1.55136 2.39421 1.63194 2.29085 1.7174C2.1875 1.80287 2.0874 1.89321 1.99137 1.99007L1.98812 1.99333C1.89209 2.08937 1.80176 2.18867 1.71712 2.29123C1.63167 2.39541 1.55111 2.50366 1.47542 2.61599C1.40055 2.72668 1.33057 2.84389 1.26465 2.96598C1.19954 3.08725 1.1377 3.21423 1.08073 3.34609L1.07666 3.35504L1.07096 3.36643C1.01969 3.48852 0.974121 3.61387 0.935059 3.74166C0.895182 3.87107 0.861816 4.00456 0.834147 4.14293C0.805664 4.28374 0.785319 4.42373 0.771484 4.56373C0.75765 4.70373 0.751139 4.84861 0.751139 4.99919C0.751139 5.14976 0.75765 5.29546 0.771484 5.43464C0.785319 5.57382 0.805664 5.71463 0.834147 5.85545C0.86263 5.99544 0.89681 6.13137 0.9375 6.26241C0.977376 6.3902 1.02295 6.51717 1.07585 6.64171C1.0791 6.6474 1.08154 6.6531 1.08398 6.6588C1.14014 6.78903 1.20036 6.91356 1.26546 7.03321C1.33138 7.1553 1.40218 7.27251 1.47624 7.3832C1.55192 7.49634 1.63249 7.60459 1.71875 7.70877C1.80176 7.8097 1.89046 7.90737 1.98405 8.00098C1.98975 8.00586 1.99463 8.01074 1.99951 8.01644C2.09391 8.11086 2.19157 8.19876 2.29167 8.28178C2.39583 8.36725 2.50407 8.44783 2.61637 8.52352C2.72705 8.5984 2.84424 8.6684 2.96631 8.73433C3.08757 8.79945 3.21452 8.86131 3.34635 8.91828L3.36344 8.92642C3.48714 8.97851 3.61328 9.02409 3.74349 9.06398C3.87207 9.10386 4.00635 9.13723 4.14388 9.1649C4.28467 9.19339 4.42464 9.21374 4.56462 9.22758C4.70459 9.24141 4.84945 9.24792 5 9.24792C5.15055 9.24792 5.29622 9.24141 5.43538 9.22758C5.57454 9.21374 5.71533 9.19339 5.85612 9.1649C5.99609 9.13642 6.132 9.10223 6.26302 9.06153C6.39242 9.02165 6.52018 8.97444 6.64632 8.92072L6.65365 8.91747V8.91665C6.7863 8.85968 6.91244 8.79863 7.03369 8.73352C7.15576 8.66759 7.27295 8.59678 7.38444 8.52189C7.49674 8.4462 7.60579 8.36562 7.70915 8.28016C7.81087 8.19632 7.90853 8.1076 8.00374 8.01237C8.00863 8.00749 8.0127 8.0026 8.01839 7.99772C8.11198 7.90412 8.19987 7.80645 8.28288 7.70633C8.36833 7.60215 8.44971 7.4939 8.52539 7.38076C8.60026 7.27006 8.67025 7.15286 8.73617 7.03077C8.80127 6.90949 8.86312 6.78333 8.92008 6.65066L8.92822 6.63275C8.98031 6.50985 9.02588 6.38369 9.06576 6.25427C9.10563 6.12486 9.139 5.99137 9.16667 5.853C9.19515 5.71219 9.2155 5.5722 9.22933 5.4322C9.24317 5.2922 9.24967 5.14732 9.24967 4.99674C9.24967 4.84617 9.24317 4.70047 9.22933 4.56129C9.2155 4.42211 9.19515 4.2813 9.16667 4.14049C9.13818 4.00049 9.104 3.86456 9.06331 3.73352C9.02344 3.6041 8.97624 3.47631 8.92253 3.35015L8.91927 3.34283C8.8623 3.21016 8.80127 3.084 8.73617 2.96272C8.67025 2.84063 8.59945 2.72342 8.52539 2.61273C8.44971 2.50041 8.36914 2.39134 8.28369 2.28797C8.20068 2.18704 8.11117 2.08856 8.01676 1.99414C8.01107 1.98926 8.00619 1.98437 8.00212 1.97949C7.90772 1.88507 7.81087 1.79717 7.70996 1.71415C7.60579 1.62868 7.49756 1.5481 7.38525 1.47241C7.27376 1.39753 7.15739 1.32753 7.03532 1.2616C6.91406 1.19648 6.78792 1.13462 6.65527 1.07846L6.63981 1.07114C6.51611 1.01905 6.38916 0.972652 6.25895 0.932769C6.13037 0.892886 5.99609 0.859515 5.85775 0.831841C5.71696 0.803353 5.57699 0.783005 5.43701 0.769168C5.29622 0.757773 5.15055 0.751262 5 0.751262ZM5.15462 2.53703C5.33285 2.53703 5.47282 2.58831 5.57454 2.69005C5.67546 2.7918 5.72673 2.93098 5.72673 3.11086C5.72673 3.29318 5.63965 3.45434 5.4655 3.59678C5.28971 3.7384 5.08626 3.81003 4.85352 3.81003C4.67936 3.81003 4.5402 3.76119 4.43359 3.66352C4.32699 3.56422 4.27409 3.43643 4.27409 3.2769C4.27409 3.07586 4.36117 2.9033 4.53369 2.75598C4.7054 2.60947 4.91292 2.53703 5.15462 2.53703ZM6.14828 7.46459H3.85173V7.07797H4.28304V4.71675H3.85173V4.40908H4.92513C5.19613 4.40908 5.46305 4.37653 5.72673 4.30978V7.07797H6.14828V7.46459ZM3.9974 0.0976722C4.1569 0.0659287 4.3221 0.0415107 4.49219 0.025232C4.66227 0.00813935 4.83154 0 5 0C5.16846 0 5.33773 0.00813935 5.50781 0.025232C5.6779 0.0415107 5.8431 0.0659287 6.0026 0.0976722C6.16048 0.129416 6.31836 0.169298 6.47624 0.218134C6.62923 0.265343 6.7806 0.32069 6.93034 0.384177L6.9458 0.389875L6.95068 0.391503C7.10124 0.456617 7.24772 0.52743 7.38851 0.603939C7.52767 0.679635 7.6652 0.762657 7.80111 0.853817C7.93376 0.94335 8.06234 1.03858 8.18604 1.14032C8.30973 1.24206 8.42773 1.34869 8.53923 1.46183C8.65153 1.57415 8.75895 1.69217 8.86068 1.81507C8.9624 1.93879 9.05762 2.06658 9.14714 2.20007C9.23584 2.33274 9.31885 2.47029 9.39616 2.61192H9.39697C9.47347 2.75354 9.54508 2.90005 9.60938 3.05063C9.611 3.0547 9.61263 3.05877 9.61426 3.06284C9.67773 3.21179 9.73307 3.36399 9.78109 3.51864C9.83073 3.67817 9.87142 3.8377 9.90316 3.99805C9.9349 4.15758 9.95931 4.32281 9.97559 4.49292C9.99186 4.66303 10 4.83233 10 5.00081C10 5.1693 9.99186 5.3386 9.97477 5.50871C9.9585 5.67882 9.93408 5.84405 9.90234 6.00358C9.87061 6.16148 9.83073 6.31939 9.7819 6.47729C9.7347 6.63112 9.67855 6.78333 9.61507 6.93472L9.61182 6.94205L9.60775 6.951C9.54264 7.10158 9.47184 7.24809 9.39534 7.3889C9.31966 7.52808 9.23665 7.66564 9.14551 7.80156C9.05599 7.93423 8.96078 8.06284 8.85905 8.18655C8.75732 8.31027 8.65072 8.42748 8.5376 8.5398C8.42529 8.65212 8.30729 8.75956 8.18359 8.86131C8.0599 8.96305 7.93213 9.05828 7.79948 9.147C7.66683 9.23572 7.5293 9.31874 7.3877 9.39606C7.24284 9.4742 7.09717 9.54583 6.94906 9.60931C6.94499 9.61094 6.94092 9.61257 6.93604 9.6142C6.78711 9.67768 6.63493 9.73303 6.48031 9.78105C6.3208 9.8307 6.1613 9.8714 6.00179 9.90314C5.84229 9.93489 5.67708 9.9593 5.507 9.97558C5.33691 9.99186 5.16764 10 4.99919 10C4.83073 10 4.66146 9.99186 4.49137 9.97558C4.32129 9.9593 4.15609 9.93489 3.99658 9.90314C3.8387 9.8714 3.68083 9.83152 3.52295 9.78268C3.36914 9.73547 3.21696 9.67931 3.06641 9.61582L3.05013 9.60931C2.89958 9.5442 2.75309 9.47338 2.6123 9.39687C2.47314 9.32118 2.33561 9.23816 2.19971 9.147C2.06706 9.05828 1.93848 8.96223 1.81559 8.86131C1.69189 8.75956 1.57389 8.65212 1.46159 8.5398C1.34928 8.42748 1.24186 8.30946 1.14014 8.18655C1.03841 8.06284 0.943197 7.93423 0.853678 7.80156C0.764974 7.66889 0.681966 7.53134 0.604655 7.38971C0.525716 7.24483 0.454915 7.09832 0.391439 6.95019C0.389811 6.94612 0.388184 6.94205 0.386556 6.93798C0.323079 6.78903 0.267741 6.63682 0.219727 6.48217C0.170085 6.32264 0.129395 6.1623 0.0976563 6.00277C0.065918 5.84324 0.0415039 5.67801 0.0252279 5.50789C0.00813802 5.3386 0 5.1693 0 5.00081C0 4.83233 0.00813802 4.66303 0.0252279 4.49292C0.0415039 4.32281 0.065918 4.15758 0.0976563 3.99805C0.129395 3.84014 0.169271 3.68224 0.218099 3.52434C0.265299 3.37132 0.320638 3.21993 0.384115 3.06935L0.391439 3.05063C0.456543 2.90005 0.527344 2.75354 0.603841 2.61273C0.679525 2.47355 0.762533 2.33599 0.853678 2.20007C0.943197 2.06739 1.03841 1.93879 1.14014 1.81507C1.24186 1.69136 1.34847 1.57415 1.46159 1.46183C1.57389 1.3495 1.69189 1.24206 1.81478 1.14032C1.93848 1.03858 2.06624 0.94335 2.19971 0.853817C2.33561 0.762657 2.47314 0.679635 2.6123 0.603939L2.62288 0.599056C2.76367 0.522546 2.90609 0.454176 3.05094 0.391503C3.05501 0.389875 3.05908 0.388247 3.06315 0.386619C3.21208 0.323132 3.36426 0.267784 3.51888 0.219762C3.67757 0.170112 3.83708 0.129416 3.9974 0.0976722Z" fill="#212C2F"/>
                    </svg>
                  </div>
                </div>
                <div class="${ID}-content-carousel-slider-item-tooltip-description">${item.tooltipDescription}</div>
              </div>` : ""}
            </li>`).join("")}
          </ul>
          <div class="${ID}-content-carousel-slider-zoom">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path d="M12.875 9.33331V16.3333" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.875 21.5833C17.5349 21.5833 21.3125 17.6658 21.3125 12.8333C21.3125 8.00082 17.5349 4.08331 12.875 4.08331C8.2151 4.08331 4.4375 8.00082 4.4375 12.8333C4.4375 17.6658 8.2151 21.5833 12.875 21.5833Z" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M24.125 24.5L19.2312 19.425L24.125 24.5ZM9.5 12.8333H16.25H9.5Z" fill="#212C2F"/>
              <path d="M24.125 24.5L19.2312 19.425M9.5 12.8333H16.25" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="${ID}-content-carousel-thumbnail swiper" thumbsSlider>
          <ul class="${ID}-content-carousel-thumbnail-wrapper swiper-wrapper">
            ${imageData.map((item) => `<li class="${ID}-content-carousel-thumbnail-item swiper-slide">
              <img src="${item.img}" alt="${item.text}" />
            </li>`).join("")}
          </ul>
        </div>

      </div>

      <div class="${ID}-content-zoom">
 
        <div class="${ID}-content-zoom-control">
          <div class="${ID}-content-zoom-control-zoom">
            <svg class="in" xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
              <path d="M12.375 9.33337V16.3334" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.375 21.5834C17.0349 21.5834 20.8125 17.6659 20.8125 12.8334C20.8125 8.00088 17.0349 4.08337 12.375 4.08337C7.7151 4.08337 3.9375 8.00088 3.9375 12.8334C3.9375 17.6659 7.7151 21.5834 12.375 21.5834Z" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23.625 24.5L18.7312 19.425L23.625 24.5ZM9 12.8334H15.75H9Z" fill="#212C2F"/>
              <path d="M23.625 24.5L18.7312 19.425M9 12.8334H15.75" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg class="out" xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
              <path d="M12.375 21.5834C17.0349 21.5834 20.8125 17.6659 20.8125 12.8334C20.8125 8.00088 17.0349 4.08337 12.375 4.08337C7.7151 4.08337 3.9375 8.00088 3.9375 12.8334C3.9375 17.6659 7.7151 21.5834 12.375 21.5834Z" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23.625 24.5L18.7312 19.425L23.625 24.5ZM9 12.8334H15.75H9Z" fill="#212C2F"/>
              <path d="M23.625 24.5L18.7312 19.425M9 12.8334H15.75" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Zoom</span>
          </div>

          <div class="${ID}-content-zoom-control-close">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path d="M15.1876 14L21.9076 7.33602C21.9901 7.25912 22.0563 7.16638 22.1022 7.06335C22.1481 6.96031 22.1728 6.84908 22.1748 6.73629C22.1768 6.6235 22.1561 6.51147 22.1138 6.40687C22.0716 6.30228 22.0087 6.20726 21.9289 6.1275C21.8491 6.04773 21.7541 5.98485 21.6495 5.94261C21.5449 5.90036 21.4329 5.87961 21.3201 5.8816C21.2073 5.88359 21.0961 5.90828 20.9931 5.95419C20.89 6.0001 20.7973 6.06629 20.7204 6.14882L14.0004 12.8128L7.33639 6.14882C7.25949 6.06629 7.16675 6.0001 7.06371 5.95419C6.96067 5.90828 6.84944 5.88359 6.73665 5.8816C6.62387 5.87961 6.51183 5.90036 6.40724 5.94261C6.30264 5.98485 6.20763 6.04773 6.12787 6.1275C6.0481 6.20726 5.98522 6.30228 5.94297 6.40687C5.90072 6.51147 5.87998 6.6235 5.88197 6.73629C5.88396 6.84908 5.90864 6.96031 5.95455 7.06335C6.00047 7.16638 6.06666 7.25912 6.14919 7.33602L12.8132 14.056L6.14919 20.664C5.99188 20.8215 5.90353 21.035 5.90353 21.2576C5.90353 21.4802 5.99188 21.6937 6.14919 21.8512C6.30669 22.0085 6.52019 22.0969 6.74279 22.0969C6.96539 22.0969 7.17889 22.0085 7.33639 21.8512L14.0564 15.1312L20.7204 21.8512C20.8779 22.0085 21.0914 22.0969 21.314 22.0969C21.5366 22.0969 21.7501 22.0085 21.9076 21.8512C22.0649 21.6937 22.1532 21.4802 22.1532 21.2576C22.1532 21.035 22.0649 20.8215 21.9076 20.664L15.1876 14Z" fill="#212C2F"/>
            </svg>
          </div>

          <div class="${ID}-content-zoom-control-navigation">
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>

          <div class="${ID}-content-zoom-control-number">
            <span class="current">1</span>
            <span class="separator">/</span>
            <span class="total">${imageData.length}</span>
          </div>
        </div>

        <div class="${ID}-content-zoom-slider swiper">
          <ul class="${ID}-content-zoom-slider-wrapper swiper-wrapper">
            ${imageData.map((item) => `<li class="${ID}-content-zoom-slider-item swiper-slide">
              <a
                href="${item.img.replace("_1024x", "")}"
                class="${ID}-content-zoom-slider-item-wrapper"
                data-pswp-width="5730" 
                data-pswp-height="5730" 
              >
                <img src="${item.img}" alt="${item.text}" />
              </a>
            </li>`).join("")}
          </ul>
        </div>

        <div class="${ID}-content-zoom-thumbnail swiper" thumbsSlider>
          <ul class="${ID}-content-zoom-thumbnail-wrapper swiper-wrapper">
            ${imageData.map((item) => `<li class="${ID}-content-zoom-thumbnail-item swiper-slide">
              <img src="${item.img}" alt="${item.text}" />
            </li>`).join("")}
          </ul>
        </div>

      </div>

    </div>`,
        q(`.${ID}-content`)
      );
      insertEle(
        q(".mobile-images-wrapper flickity-carousel"),
        "beforebegin",
        `<div class="${ID}-mobile-zoom-button">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path d="M12.875 9.33331V16.3333" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.875 21.5833C17.5349 21.5833 21.3125 17.6658 21.3125 12.8333C21.3125 8.00082 17.5349 4.08331 12.875 4.08331C8.2151 4.08331 4.4375 8.00082 4.4375 12.8333C4.4375 17.6658 8.2151 21.5833 12.875 21.5833Z" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M24.125 24.5L19.2312 19.425L24.125 24.5ZM9.5 12.8333H16.25H9.5Z" fill="#212C2F"/>
        <path d="M24.125 24.5L19.2312 19.425M9.5 12.8333H16.25" stroke="#212C2F" stroke-width="1.4375" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>`,
        q(`.${ID}-mobile-zoom-button`)
      );
      expLog("content-added", q(`.${ID}-content`));
    }

    // src/Twentythree/TWE-104/1/index.js
    window.runningExperiments = window.runningExperiments || {};
    window.runningExperiments[ID] = {
      name: "Rework image gallery on PDP",
      logs: []
    };

    waitFor(
      () => q(`body:not(.${ID}-${VAR}) .mobile-images-wrapper`),
      (base) => {
        q("body").classList.add(ID, `${ID}-${VAR}`);
        expLog("variation", ID, VAR);
        addContent(base);
        waitFor(
          () => q(`.${ID}-content`) && window.Swiper && window.PhotoSwipe && window.PhotoSwipeLightbox,
          () => {
            addBehavior();
          }
        );
      }
    );
  })();
  */

//# sourceURL=ABtest/TWE-104_1.js
